import React from "react";
import { Flex, Input, Spin } from "antd";
import { IoArrowBack } from "react-icons/io5";
import DoctorListItem from "./DoctorListItem";

function AllDoctorsList({
  doctors,
  isLoading,
  error,
  sentinelRef,
  onSelectDoctor,
  onBack,
  onSearchChange,
}) {
  return (
    <>
      <div className="flex gap-1 items-center p-4 border-b">
        <IoArrowBack
          className="font-medium w-6 h-6 text-iconBlue mx-2 cursor-pointer"
          onClick={onBack}
        />
        <Input
          type="text"
          placeholder="Search"
          className="flex-1 px-4 py-2 rounded-full bg-gray-100 outline-none"
          onChange={onSearchChange}
        />
      </div>
      <div>
        {error && (
          <p className="text-center text-sm text-red-500 py-2">{error}</p>
        )}
        {isLoading && doctors.length === 0 ? (
          <div className="h-screen flex items-center justify-center">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : (
          doctors.map((doctor) => (
            <DoctorListItem
              key={doctor.userId}
              doctor={doctor}
              onClick={() => onSelectDoctor(doctor)}
            />
          ))
        )}
        <div ref={sentinelRef} />
      </div>
    </>
  );
}

export default AllDoctorsList;